import { createSelector } from 'reselect';
import type { RootState } from 'typesafe-actions';

import type { heroImagesState } from './reducer';

export const getHeroImages = (state: RootState) => state.heroImages;

export const getItems = createSelector(getHeroImages, (state: heroImagesState) => state.items);
export const getIsFetching = createSelector(
  getHeroImages,
  (state: heroImagesState) => state.isFetching,
);
